import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { CedulaDigital } from '../models/ceduladigital';
import {formatDate} from '@angular/common';
import {map, catchError} from 'rxjs/operators';
import swal from 'sweetalert2';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';
 
@Injectable({
  providedIn: 'root'
})
export class CedulaDigitalService {
 
  //private baseEndPoint='http://cnsfdesmic3:9009/cnsf/agentesDescargaCedula'; //>>>>DESARROLLO
  //private baseEndPoint='https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>DESARROLLO_v2
  //private baseEndPointPdf='https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/';

  //private baseEndPoint='https://cnsfdesprorr.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'

  private baseEndPoint='https://ceduladigital.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>PRODUCCION
  private baseEndPointPdf='https://ceduladigital.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/';

  //private baseEndPoint='https://ceduladigitaldrp.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula'; //>>>>DRP
  //private baseEndPointPdf='https://ceduladigitaldrp.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/';

  //private baseEndPoint='http://localhost:8900'; //>>>>LOCAL
  

  constructor(private http: HttpClient,
    private route:Router) { 
      
    }
    
    getCedulas(rfc:string): Observable<CedulaDigital[]>{
      
      var reqHeader = new HttpHeaders({ 
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
     });
       
      return this.http.get(`${this.baseEndPoint}/cedulas/${rfc}`,  {headers: reqHeader}).pipe(
        map( reponse => {
          let cedulas = reponse as CedulaDigital[];
  
          return cedulas.map(
            cedula => {
              
              cedula.fechaimpresion = formatDate(cedula.fechaimpresion, 'yyyy-MM-dd', 'en-US');
              return cedula;
            }
          );
        })
      ); 
    }
    updateConstancia(ceduladigital: CedulaDigital): Observable<any>{
      var reqHeader = new HttpHeaders({ 
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
     });
      return this.http.put<any>(`${this.baseEndPoint}/actualiza/${ceduladigital.id}`,ceduladigital, {headers: reqHeader}).pipe(
        catchError(e => {
          if(e.status == 400){
            swal.fire(e.error.mensaje, e.error.error,'error');
            return throwError(e);
          }
          swal.fire(e.error.mensaje, e.error.error,'error');
          return throwError(e);
        })
      )
    }

    downloadPdf(filename : number){
      return this.http.get(this.baseEndPointPdf+filename, { responseType: 'blob' });
    }
}
